import { useEffect, useState } from 'react'
import { Customer } from '../../model/Customer'
import { ProviderValue, useAxios } from '../../config/axios-config'
import { PageLoader } from '../util/PageLoader'
import { CustomerResponseDTO, CustomersResponseDTO } from '../../model/ResponsesDTO'
import { Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap'
import { Pagination, Stack } from '@mui/material';
import { CustomerElement } from './CustomerElement'
import { SaveEditCustomerModal } from '../modal/SaveEditCustomerModal'
import { CustomerRequestDTO } from '../../model/CustomerRequestDTO'
import { Meal } from '../../model/Meal'
import { HeaderSorterColumn } from '../util/HeaderSorterColumn'
import { DinneyObject } from '../../model/DinneyObject'
import { isMobile } from 'react-device-detect';
import { MAX_CUSTOMERS } from '../util/DinneyConst'
import './style.css'
import { Empty, Popover, Switch } from 'antd'
import { ErrorPage } from '../error/ErrorPage'
import { AlertBar } from '../util/AlertBar'
import { Entities } from '../util/Entities'
import { DinneyResponseStatus } from '../util/DinneyResponseStatus'
import {DinneyUtil} from "../util/DinneyUtil";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from "@mui/material/Tooltip";

export const CustomersPage = () => {

  const axiosInstance = useAxios() as ProviderValue
  const [customersList, setCustomersList] = useState<Customer[]>([])
  const [mealList, setMealList] = useState<Meal[]>([])
  const [filteredCustomersList, setFilteredCustomersList] = useState<Customer[]>([])
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [filter, setFilter] = useState<string>('')
  const [filterActive, setFilterActive] = useState<boolean>(true)
  const [count, setCount] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [show, setShow] = useState(false);
  const controller = new AbortController();
  const signal = controller.signal

useEffect(() => {
  axiosInstance.get<CustomersResponseDTO>("/customers/secure/fetch/all", {signal})
    .then(response => {
      handleSort('position', true, response.data.customers)
      setMealList(response.data.meals)
      setIsLoaded(true)
      setIsError(false)
    }).catch((e : any) => {
      setIsLoaded(true)
      setIsError(true)
      console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
      }) 
    
      return () => {
        controller.abort()
      }
// eslint-disable-next-line 
},[])

useEffect(() => { },[filter])

const handleSaveToDatabase = async (customerRequestDTO : CustomerRequestDTO) => {
  setIsLoaded(false)
  let tempCustomer : Customer | undefined
  let tempCustomerList = customersList

  if (customerRequestDTO.customer.customerid === undefined) {
    await axiosInstance.post<CustomerResponseDTO>(`/customers/secure/save`, customerRequestDTO, {signal}).then((response) => {
      tempCustomer = response.data.customer
      tempCustomer.customerMeals = []
    }).catch((e) => {
      setIsLoaded(true) 
      setIsError(true)
      console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
    })
    if (tempCustomer !== undefined) {
      tempCustomerList.push(tempCustomer)
    }
  } else {
    await axiosInstance.put<CustomerResponseDTO>(`/customers/secure/update`, customerRequestDTO, {signal}).then((response) => {
      tempCustomer = response.data.customer
    }).catch((e) => {
      setIsLoaded(true) 
      setIsError(true)
      console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
    })
    if (tempCustomer !== undefined) {
      tempCustomerList = customersList.filter(customer => customer.customerid !== tempCustomer?.customerid)
      tempCustomerList.push(tempCustomer)
    }
  }
  
  handleSort('position', true, tempCustomerList)
  setFilterActive(true)
  setIsLoaded(true) 
  return () => {
    controller.abort()
  }
}

const handleDeleteOrRestore = async (id : number, isDelete : boolean) => {
  setIsLoaded(false) 
  await axiosInstance.delete<CustomerResponseDTO>(`/customers/secure/${isDelete ? `d` : `r`}eactivate/${id}`, {signal}).then((response) => {
    let tempCustomer = customersList.filter(customer => customer.customerid !== id)
    tempCustomer.push(response.data.customer)
    handleSort('position', true, tempCustomer)
    setIsLoaded(true) 
  }).catch((e) => {
    console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
    setIsLoaded(true) 
    setIsError(true)
  })
  return () => {
    controller.abort()
  }
};

const handleHardDelete = async (id : number) => {
  setIsLoaded(false) 
  await axiosInstance.delete<DinneyResponseStatus>(`/customers/secure/delete/${id}`, {signal}).then((response) => {
    let tempCustomer = customersList.filter(customer => customer.customerid !== id)
    handleSort('lastName', true, tempCustomer)
    setIsLoaded(true) 
  }).catch((e) => {
    console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
    setIsLoaded(true) 
    setIsError(true)
  })

  return () => {
    controller.abort()
  }
};

const handleSort = (column : string, descending: boolean, list? : DinneyObject[]) => {
  let listToSort = list as Customer[] === undefined ? customersList : list as Customer[]
  let sortedCustomersList = [...listToSort!].sort((a,b) => {
    switch (column) {
      case 'firstName':
        return DinneyUtil.setOrder(a.firstName.toLowerCase(), b.firstName.toLowerCase(),
            a.customerid, b.customerid, descending)
      case 'childName':
        return DinneyUtil.setOrder(a.childName.toLowerCase(), b.childName.toLowerCase(),
            a.customerid, b.customerid, descending)
      case 'email': 
        if (a.email.toLowerCase() < b.email.toLowerCase()) {
          return descending ? -1 : 1
        } 
        if (a.email.toLowerCase() > b.email.toLowerCase()) {
          return descending ? 1 : -1
        }
        return DinneyUtil.setOrder(a.email.toLowerCase(), b.email.toLowerCase(),
            a.customerid, b.customerid, descending)
      case 'description':
        return DinneyUtil.setOrder(a.description.toLowerCase(), b.description.toLowerCase(),
            a.customerid, b.customerid, descending)
      case 'position':
        return DinneyUtil.setOrder(a.position, b.position, a.customerid, b.customerid, descending)
      case 'activeStart': 
        if (a.activeStart < b.activeStart) {
          return descending ? -1 : 1
        } 
        if (a.activeStart > b.activeStart) {
          return descending ? 1 : -1
        }
        return DinneyUtil.setOrder(a.activeStart, b.activeStart,
            a.customerid, b.customerid, descending)
      case 'activeEnd': 
        if (a.activeEnd < b.activeEnd) {
          return descending ? -1 : 1
        } 
        if (a.activeEnd > b.activeEnd) {
          return descending ? 1 : -1
        }
        return DinneyUtil.setOrder(a.activeEnd, b.activeEnd,
            a.customerid, b.customerid, descending)
      default:
        return DinneyUtil.setOrder(a.lastName.toLowerCase(), b.lastName.toLowerCase(),
            a.customerid, b.customerid, descending)
    }
  })
  setCustomersList(sortedCustomersList)
  let tempFilteredCustomersList = sortedCustomersList.filter(customer => customer.active === filterActive)
  setFilteredCustomersList(tempFilteredCustomersList)
  setCount(Math.ceil(tempFilteredCustomersList.length/10))
}

const handleFilter = (phrase : string) => {
  let tempFilteredCustomersList = customersList.filter(customer => (`${customer.firstName} ${customer.lastName} ${customer.childName}`).toLocaleLowerCase().includes(phrase.toLowerCase()))
  setPage(1)
  setCount(Math.ceil(tempFilteredCustomersList.length/10))
  setFilteredCustomersList(tempFilteredCustomersList)
  setFilter(phrase)
}

const handleFilterActive = (isActive : boolean) => {
  setPage(1)
  handleFilter('')
  let tempFilteredCustomersList = customersList.filter(customer => customer.active === isActive)
  setCount(Math.ceil(tempFilteredCustomersList.length/10))
  setFilteredCustomersList(tempFilteredCustomersList)
  setFilterActive(prev => !prev); 
}

const handleLastPosition = (list : Customer[]) : number => {
  if (list.length < 1) {
    return 1
  }
  let lastPosition = list.map(customer => customer.position)[list.length-1]

  return lastPosition > 99 ? 100 : lastPosition
  }

  if (!isLoaded) {
      return (
          <PageLoader />
      )
  }

  if (isError) {
        return (
          <ErrorPage />
        )
  }

  return (
    <>
      <Container fluid className={'my-4'}>
        {isMobile ?
        <>
        <Row>
          {filteredCustomersList[0]?.active === true && filteredCustomersList.length >= MAX_CUSTOMERS ?
            <Popover placement="right" content={'Osiągnięto maksymalną liczbę rodziców na liście.'}>
              <button disabled className='button-65-mobile mb-3' onClick={() => setShow(true)}>
                Dodaj rodzica
              </button>
            </Popover>
          :
            <button disabled={!filterActive}  className='button-65-mobile mb-3' onClick={() => setShow(true)}>
              Dodaj rodzica
            </button>
          }
        </Row>
        <Row>
        <InputGroup className="mb-1 p-0">
            <Form.Control
              value={filter}
              size="sm"
              placeholder="Filtruj po imieniu i nazwisku"
              aria-label="Filtruj po imieniu i nazwisku"
              aria-describedby="basic-addon2"
              onChange={(e) => handleFilter(e.target.value)}
            />
          </InputGroup>
          <button className='button-65-mobile' onClick={() => handleFilter('')}>
              Wyczyść
          </button>
        </Row>
        </>
        :
        <Row>
          <Col>
          {filteredCustomersList[0]?.active === true && filteredCustomersList.length >= MAX_CUSTOMERS?
            <Popover placement="right" content={'Osiągnięto maksymalną liczbę rodziców na liście.'}>
              <button disabled className='button-65' onClick={() => setShow(true)}>
                Dodaj rodzica
              </button>
            </Popover>
          :
            <button disabled={!filterActive} className='button-65' onClick={() => setShow(true)}>
              Dodaj rodzica
            </button>
          }
          </Col>
          <Col>
          </Col>
          <Col className='float-end text-end'>
          <InputGroup className="mb-3">
            <Form.Control
              value={filter}
              placeholder="Filtruj po imieniu i nazwisku rodzica lub dziecka"
              aria-label="Filtruj po imieniu i nazwisku rodzica lub dziecka"
              aria-describedby="basic-addon2"
              onChange={(e) => handleFilter(e.target.value)}
            />
            <button className='button-65' onClick={() => handleFilter('')}>
              Wyczyść
            </button>
          </InputGroup>
          </Col>
        </Row>
        }
        
      </Container>
      <AlertBar listLength={customersList.length} limit={MAX_CUSTOMERS} entity={Entities.CUSTOMER}/>
      <Switch
              size = "small"
              checkedChildren="Pokaż aktywnych" 
              unCheckedChildren="Pokaż nieaktywnych"
              checked={filterActive}
              onClick={() => handleFilterActive(!filterActive)}
      />
      <Table striped={filteredCustomersList !== undefined && filteredCustomersList.length > 0 } responsive>
        <thead>
        <tr>
          {isMobile ? <></> : <th>#</th>}
          <th>
            <HeaderSorterColumn columnName={isMobile ? 'Poz.' : 'Pozycja'} sortCondition={'position'}
                                handleSort={handleSort}/>
          </th>
          <th>
            <HeaderSorterColumn columnName={isMobile ? 'Imię' : 'Imię rodzica'} sortCondition={'firstName'}
                                handleSort={handleSort}/>
          </th>
          <th>
            <HeaderSorterColumn columnName={isMobile ? 'Nazwisko' : 'Nazwisko rodzica'} sortCondition={'lastName'}
                                handleSort={handleSort}/>
          </th>
          {isMobile ?
              <></>
              :
              <>
                <th>
                  <HeaderSorterColumn columnName={'Imię i nazwisko dziecka'} sortCondition={'childName'}
                                      handleSort={handleSort}/>
                </th>
                <th>
                  <HeaderSorterColumn columnName={'Email'} sortCondition={'email'} handleSort={handleSort}/>
                </th>
                <th>
                  <HeaderSorterColumn columnName={'Opis'} sortCondition={'description'} handleSort={handleSort}/>
                </th>
              </>
          }
          {isMobile ?
              <>
                <th className={'mobile-text-size'}>
                  {'S.G.P.'}
                </th>
                <th className={'mobile-text-size'}>{'A.'}</th>
              </>
              :
              <>
              <th>
                {'S.G.P.'}
                <Tooltip title="Kolumna zawiera informację, czy rodzic ma założone konto do samodzielnego
            zgłaszania posiłków. Jeśli nie, możesz kliknąć przycisk aby takie konto utworzyć - użytkownik
            otrzyma na swój adres mailowy dalsze szczegóły związane z aktywacją konta."
                         arrow placement="right">
                  <HelpOutlineIcon fontSize="small" sx={{color: '#C5B5F2', marginLeft: '0.5rem'}}/>
                </Tooltip>
              </th>
              <th>{'Akcja'}</th>
              </>
        }
        </tr>
        </thead>
        <tbody>
        {filteredCustomersList !== undefined && filteredCustomersList.length > 0
            ?
            filteredCustomersList
            .filter((customer : Customer, index : number) => {return index >= (page*10)-10 && index < page*10 && customer.active === filterActive})
            .map((customer : Customer, index : number) => (
              <CustomerElement key={index} 
              customer={customer} 
              show={show} 
              setShow={setShow} 
              index={index}
              lengthOfCustomersList={customersList.length}
              handleSaveToDatabase={handleSaveToDatabase}
              handleDeleteOrRestore={handleDeleteOrRestore}
              handleHardDelete={handleHardDelete}
              mealList={mealList}
              page={page}
              isListLimitActive={customersList.filter(customer => customer.active === true).length >= MAX_CUSTOMERS}
              isListLimitInactive={customersList.filter(customer => customer.active === false).length >= MAX_CUSTOMERS}/>
              ))
          
        :
        <tr>
          <td colSpan={7}>
            <Empty description={<>{`${filter.length > 0 ? `Nic nie znaleziono` : `Nie dodano jeszcze rodzica`}`}</>} className='my-4'/>
          </td>
        </tr>
        }
        </tbody>
      </Table>
      <Stack spacing={2} alignItems={isMobile ? "left" : "center"}  justifyContent="center">
        <Pagination count={count} defaultPage={1} page={page} boundaryCount={2} onChange={(e, v) => setPage(v)} size="large" variant="outlined" color="secondary"/>
      </Stack>
      <SaveEditCustomerModal key={0} customer={null} show={show} setShow={setShow} index={null}
                             lengthOfCustomersList={handleLastPosition(customersList)}
                             handleSaveToDatabase={handleSaveToDatabase} mealList={mealList}/>
    </>
  )
}